export default __webpack_public_path__ + "static/media/codmw.c6068a46.jpg";